import api from '../../api/'
const state = {
    all:[],
    active_atm:[]
}

const getters= {
    rows(state){
        let data = []
        let row = {
            id: "",
            agence_id: "",
            agence_nom: "",
            agence_ville: "",
            nom: "",
            solde: "",
            active: "",
            created_at: null,
            updated_at: null,
            deleted_at: null,
            btn:""
        }
        state.all.forEach(element => {           
            row = {
                id: element.id,
                agence_id: element.agence_id,
                agence_nom: element.agence_nom.toUpperCase(),
                agence_ville: element.agence_ville.toUpperCase(),
                nom: element.nom.toUpperCase(),
                solde: element.solde.toLocaleString(),
                active: element.active === 1 ? 'activé' : 'désactivé',
                created_at: element.created_at,
                deleted_at: element.deleted_at,
                updated_at: element.updated_at,
                //btn: ""
            }
            data.push(row)
        });
        return data;
    },
    rows_active(state){
        let data = []
        let row = {
            id: "",
            nom: "",
            solde: "",
            active: "",
            created_at: null,
            updated_at: null,
            deleted_at: null,
            btn:""
        }
        state.active_atm.forEach(element => {           
            row = {
                id: element.id,
                nom: element.nom.toUpperCase(),
                solde: element.solde.toLocaleString(),
                active: element.active,
                created_at: element.created_at,
                deleted_at: element.deleted_at,
                updated_at: element.updated_at,
                //btn: ""
            }
            data.push(row)
        });
        return data;
    }
}
const mutations= {
    setATM(state, guichets) {
        state.all = guichets
    },
    setActiveATM(state, guichets) {
        state.active_atm = guichets
    },
    addATM(state, guichet) {
        state.all.push(guichet)
    }
}

const actions={
    get_all_atms({ commit }){
        return api.atm.get_all_atms().then((response)=>{
            commit('setATM', response.data.data.data)
            return response.data.data.data
        })
    },
    get_all_atms_own({ commit }, serverParams){        
        return api.atm.get_all_atms_own(serverParams).then((response)=>{
            commit('setATM', response.data.data.data)
            return response.data.data
        })
    },
    guichet_active({ commit }){        
        return api.atm.guichet_active().then((response)=>{
            
            commit('setActiveATM', response.data.data)
            return response.data
        })
    },
    get_all_atms_by_agency({ commit },agency_id){
        return api.atm.get_all_atms_by_agency(agency_id).then((response)=>{
            commit('setATM', response.data.data.data)
            return response.data.data.data
        })
    },
    post_guichets({commit},guichet){
        return api.atm.post_guichets(guichet).then((response)=>{
            return response.data
        })
        .catch(error=>{
            //console.log('error guichet post :', error.response)
            return error.response.data
        })
    },
    put_guichets({ commit }, data) {
        return api.atm.put_guichets(data.id, data.atm).then((response) => {
            //commit('addAgency', response.data.data)
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    show_guichets({ commit }, id) {
        return api.atm.show_guichets(id).then((response) => {
            return response.data.data;
        })
    },
    delete_guichets({ commit }, id) {
        return api.atm.delete_guichets(id).then((response) => {
            return response.data;
        })
        .catch(error => {
            return error.response.data
        })
    },
    active_guichets({ commit }, id) {
        return api.atm.active_guichets(id).then((response) => {
            console.log(response)
            return response.data;
        })
        .catch(error => {
            return error.response.data
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
